import { memo } from 'react';
import { useSelector } from 'react-redux';

import { IconPhotosOutline } from '@zillow/constellation-icons';
import { Box, Icon } from '@zillow/constellation-10';
import { BigDropzone, SmallDropzone } from '@zg-rentals/maintenance-utils';

import { AppSelectors } from '../../selectors';
import { containerRecipe } from './styles';

import type { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone';
import type { ReactNode } from 'react';

type Props = {
  isSmallDropzone?: boolean;
  isDisabled?: boolean;
  isEmpty?: boolean;
  rootProps: DropzoneRootProps;
  inputProps: DropzoneInputProps;
  displayText?: string;
  IconToDisplay?: ReactNode;
};

const UploadDropzone = ({
  isSmallDropzone = false,
  isDisabled = false,
  isEmpty = false,
  rootProps,
  inputProps,
  displayText = '',
  IconToDisplay = <IconPhotosOutline />,
}: Props) => {
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  const { isDragAccept, isDragReject } = rootProps;

  const isContainerSizeFixed = (isScreenMobile || isSmallDropzone) && isEmpty;

  return (
    <Box
      css={containerRecipe.raw({
        isContainerSizeFixed,
        isSmallDropzone,
        isDisabled,
        isDragReject,
        isDragAccept,
      })}
      {...rootProps}
    >
      <input {...inputProps} />

      <Icon render={IconToDisplay} size="lg" css={{ color: isDragAccept ? 'icon.accent.brand.hero' : undefined }} />
      {isScreenMobile || isSmallDropzone ? (
        <SmallDropzone />
      ) : (
        <BigDropzone displayText={displayText} disabled={isDisabled} />
      )}
    </Box>
  );
};

export default memo(UploadDropzone);
